import React, { useContext, useEffect, useState } from "react";
import organisms from "../../../../components/organisms";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import { HeaderHeading } from "../../../../Context";
import constant from "../../../../constants/constant";
import molecules from "../../../../components/molecules";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const { RoleLayout } = molecules

const { Role } = organisms;
const Index = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const assignedTo = searchParams.get('role_for') || constant.ROLE_FOR[1].id;

    const [rolesList, setRolesList] = useState();
    const [subAdminRole, setSubAdminRole] = useState<{
        label: string;
        value: number;
        id:string;
    }>(constant.ROLE_FOR[1]);
    const { setHeader }: any = useContext(HeaderHeading);
    const getRolesList = async () => {
        try {
            let response = await service.roles.list({
                role_for: Number(assignedTo),
            });
            setRolesList(response.data);
        } catch (error) {
            console.error(error);
        }
    };
    const tabs = [
        {
            id: constant.ROLE_FOR[1].id,
            label: "Store Role",
            target: "pane-one",
            Content: <Role rolesList={rolesList} subAdminRole={subAdminRole} addRolePath={`/settings/role/add?assignedTo=${constant.ROLE_FOR[1].id}`} />,
        },
        {
            id: constant.ROLE_FOR[2].id,
            label: "Staff Role",
            target: "pane-two",
            Content: <Role rolesList={rolesList} subAdminRole={subAdminRole} addRolePath={`/settings/role/add?assignedTo=${constant.ROLE_FOR[2].id}`} />,
        },
    ];

    // 

    const onChangeTab = (value: string) => {
        const requiredTab = constant.ROLE_FOR.find((item) => item?.id === value);
        if (requiredTab) {
            // setSubAdminRole(requiredTab);
            navigate(`/settings/role?role_for=${value}`);
        }
    };

    useEffect(() => {
        setHeader("Setting - Roles");
    }, []);

    useEffect(() => {
        const requiredTab = constant.ROLE_FOR.find((item) => item.id === assignedTo);
        if (requiredTab && subAdminRole.id !== assignedTo) {
            setSubAdminRole(requiredTab);
        }
    }, [assignedTo]);

    useEffect(() => {
        getRolesList();
    }, [subAdminRole]);

    return (
        <Wrapper>
            <RoleLayout onClear={(value: string) => onChangeTab(value)} tabs={tabs} activeTabId={subAdminRole.id} />
        </Wrapper>
    );
};

export default Index;
